var _templateObject;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import _styled from '@emotion/styled/base';
import { keyframes } from '@emotion/react';
import { getThemeValue } from '@tablekit/utils';
import { spinnerThemeNamespace, spinnerClassicTheme } from '../themes.js';
var rotationKeyframe = keyframes(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    to { transform: rotate(360deg); }\n  "])));

var SpinnerSvg = _styled("svg", process.env.NODE_ENV === "production" ? {
  target: "erqvlei0"
} : {
  target: "erqvlei0",
  label: "SpinnerSvg"
})("fill:none;stroke:", getThemeValue("".concat(spinnerThemeNamespace, ".fillColor"), spinnerClassicTheme.fillColor), ";stroke-dasharray:100px;stroke-dashoffset:100px;stroke-width:10px;transform-origin:center;width:100%;height:100%;animation:", rotationKeyframe, " linear 0.86s infinite;");

export { SpinnerSvg };
